module.exports = __webpack_public_path__ + "static/media/image-card-1.dba3b413.png";